import React, { useState } from "react";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../features/auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import UserMenu from "../../vendor/common/Header";
import {
  FaUser,
  FaLayerGroup,
  FaBuromobelexperte,
  FaGlobe,
  FaUsers,
  FaChartArea,
  FaCity,
  FaCheck,
  FaSearchengin,
  FaSignal,
  FaStar,
  FaBars,
} from "react-icons/fa";
import { GrCatalog } from "react-icons/gr";
import { MdLeaderboard, MdMiscellaneousServices, MdLocalMall } from "react-icons/md";

import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
} from "react-pro-sidebar";

export const AdminHeader = () => {
  const loggedInUser = useSelector((state) => state.auth);
  const userRoles = loggedInUser?.user?.user?.roles;
  const userType = loggedInUser?.user?.user?.userType?.name;

  const [expandedSubMenu, setExpandedSubMenu] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [broken, setBroken] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = async () => {
    dispatch(logout());
    navigate("/login");
  };

  const navLinks = [
    {
      heading: "User Management",
      links: [
        { to: "/user", label: "Customer", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaUser /> },
        { to: "/partners", label: "Partner", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaUser /> },
        { to: "/allhomedesire", label: "Employee", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaUser /> },
        { to: "/user-type", label: "User Type", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaUsers /> },
      ],
    },
    {
      heading: "Core Data Management",
      links: [
        { to: "/service", label: "Services", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaCheck /> },
        { to: "/property-purpose", label: "Property Purpose", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaSearchengin /> },
        { to: "/property-type", label: "Property Type", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaStar /> },
        { to: "/property-subtype", label: "Property Sub Type", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaStar /> },
        { to: "/property-sub-sub-type", label: "Property Sub Sub Type", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaStar /> },
        { to: "/property-status", label: "Property Status", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaSignal /> },
        { to: "/property-stages", label: "Property Stages", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaSignal /> },
        { to: "/land-types", label: "Land Type", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaSignal /> },
        { to: "/catalog-types", label: "Catalog Type", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <GrCatalog /> },
        { to: "/all-services", label: "All Services", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <MdMiscellaneousServices /> },
        { to: "/subscription-plans", label: "Subscription plans", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <MdMiscellaneousServices /> },
        { to: "/local-bazaar", label: "Local Bazaar", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <MdLocalMall /> },
      ],
    },
    {
      heading: "Location Management",
      links: [
        { to: "/country", label: "Country", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaGlobe /> },
        { to: "/state", label: "State", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaBuromobelexperte /> },
        { to: "/city", label: "City", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaCity /> },
        { to: "/area", label: "Area", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaChartArea /> },
      ],
    },
    {
      heading: "Content Management",
      links: [
        { to: "/blog", label: "Blog", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <FaLayerGroup /> },
      ],
    },
    {
      heading: "Leads Management",
      links: [
        { to: "/upload-leads", label: "Leads", allowed: ["SUPER_ADMIN", "ALL_HOME_DESIRE"], icon: <MdLeaderboard /> },
      ],
    },
  ];

  return (
    <div className="admin-header">
      {userType === "PARTNER" && (
        <UserMenu userType={userType} userRoles={userRoles} />
      )}

      {(userType === "ALL_HOME_DESIRE" || userType === "SUPER_ADMIN") && (
        <>
          <Sidebar
            collapsed={collapsed}
            toggled={toggled}
            onBackdropClick={() => setToggled(false)}
            onBreakPoint={setBroken}
            breakPoint="md"
            className="admin-header__sidebar"
          >
            <Menu className="admin-header__menu">
              {navLinks.map((group, index) => (
                <SubMenu
                  key={index}
                  label={group.heading}
                  className="admin-header__submenu"
                  open={expandedSubMenu === index}
                  onOpenChange={(open) =>
                    setExpandedSubMenu(open ? index : null)
                  }
                >
                  {group.links.map((link, i) =>
                    (link.allowed?.includes(userType) || !link.allowed) && (
                      <Link key={i} to={link.to} className="admin-header__link">
                        <MenuItem icon={link.icon}>
                          {link.label}
                        </MenuItem>
                      </Link>
                    )
                  )}
                </SubMenu>
              ))}
            </Menu>
          </Sidebar>

          {broken && (
            <button
              className="admin-header__toggle"
              onClick={() => setToggled(!toggled)}
            >
              <FaBars />
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default AdminHeader;